var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Sparkline base API Class declarations.
 */
import { Property, ChildProperty, Complex } from '@syncfusion/ej2-base';
/**
 * Configures the borders in the Sparkline.
 */
export class SparklineBorder extends ChildProperty {
}
__decorate([
    Property('')
], SparklineBorder.prototype, "color", void 0);
__decorate([
    Property(0)
], SparklineBorder.prototype, "width", void 0);
/**
 * Configures the fonts in sparklines.
 */
export class SparklineFont extends ChildProperty {
}
__decorate([
    Property(null)
], SparklineFont.prototype, "size", void 0);
__decorate([
    Property(null)
], SparklineFont.prototype, "color", void 0);
__decorate([
    Property('Roboto, Segoe UI, Noto, Sans-serif')
], SparklineFont.prototype, "fontFamily", void 0);
__decorate([
    Property(null)
], SparklineFont.prototype, "fontWeight", void 0);
__decorate([
    Property(null)
], SparklineFont.prototype, "fontStyle", void 0);
__decorate([
    Property(1)
], SparklineFont.prototype, "opacity", void 0);
/**
 * To configure the tracker line settings.
 */
export class TrackLineSettings extends ChildProperty {
}
__decorate([
    Property(false)
], TrackLineSettings.prototype, "visible", void 0);
__decorate([
    Property(null)
], TrackLineSettings.prototype, "color", void 0);
__decorate([
    Property(1)
], TrackLineSettings.prototype, "width", void 0);
/**
 * To configure the tooltip settings for sparkline.
 */
export class SparklineTooltipSettings extends ChildProperty {
}
__decorate([
    Property(false)
], SparklineTooltipSettings.prototype, "visible", void 0);
__decorate([
    Property('')
], SparklineTooltipSettings.prototype, "fill", void 0);
__decorate([
    Property('')
], SparklineTooltipSettings.prototype, "template", void 0);
__decorate([
    Property('')
], SparklineTooltipSettings.prototype, "format", void 0);
__decorate([
    Complex({ color: null, width: null }, SparklineBorder)
], SparklineTooltipSettings.prototype, "border", void 0);
__decorate([
    Complex({ size: '12px', fontWeight: null, fontStyle: 'Normal', fontFamily: null }, SparklineFont)
], SparklineTooltipSettings.prototype, "textStyle", void 0);
__decorate([
    Complex({}, TrackLineSettings)
], SparklineTooltipSettings.prototype, "trackLineSettings", void 0);
/**
 * To configure the sparkline container area customization
 */
export class ContainerArea extends ChildProperty {
}
__decorate([
    Property('transparent')
], ContainerArea.prototype, "background", void 0);
__decorate([
    Complex({}, SparklineBorder)
], ContainerArea.prototype, "border", void 0);
/**
 * To configure axis line settings
 */
export class LineSettings extends ChildProperty {
}
__decorate([
    Property(false)
], LineSettings.prototype, "visible", void 0);
__decorate([
    Property(null)
], LineSettings.prototype, "color", void 0);
__decorate([
    Property('')
], LineSettings.prototype, "dashArray", void 0);
__decorate([
    Property(1)
], LineSettings.prototype, "width", void 0);
__decorate([
    Property(1)
], LineSettings.prototype, "opacity", void 0);
/**
 * To configure the sparkline rangeband.
 */
export class RangeBandSettings extends ChildProperty {
}
__decorate([
    Property(null)
], RangeBandSettings.prototype, "startRange", void 0);
__decorate([
    Property(null)
], RangeBandSettings.prototype, "endRange", void 0);
__decorate([
    Property(null)
], RangeBandSettings.prototype, "color", void 0);
__decorate([
    Property(1)
], RangeBandSettings.prototype, "opacity", void 0);
/**
 * To configure the sparkline axis.
 */
export class AxisSettings extends ChildProperty {
}
__decorate([
    Property(null)
], AxisSettings.prototype, "minX", void 0);
__decorate([
    Property(null)
], AxisSettings.prototype, "maxX", void 0);
__decorate([
    Property(null)
], AxisSettings.prototype, "minY", void 0);
__decorate([
    Property(null)
], AxisSettings.prototype, "maxY", void 0);
__decorate([
    Property(0)
], AxisSettings.prototype, "value", void 0);
__decorate([
    Complex({}, LineSettings)
], AxisSettings.prototype, "lineSettings", void 0);
/**
 * To configure the sparkline padding.
 */
export class Padding extends ChildProperty {
}
__decorate([
    Property(5)
], Padding.prototype, "left", void 0);
__decorate([
    Property(5)
], Padding.prototype, "right", void 0);
__decorate([
    Property(5)
], Padding.prototype, "bottom", void 0);
__decorate([
    Property(5)
], Padding.prototype, "top", void 0);
/**
 * To configure the sparkline marker options.
 */
export class SparklineMarkerSettings extends ChildProperty {
}
__decorate([
    Property([])
], SparklineMarkerSettings.prototype, "visible", void 0);
__decorate([
    Property(1)
], SparklineMarkerSettings.prototype, "opacity", void 0);
__decorate([
    Property(8)
], SparklineMarkerSettings.prototype, "size", void 0);
__decorate([
    Property('#00bdae')
], SparklineMarkerSettings.prototype, "fill", void 0);
__decorate([
    Complex({ width: 1 }, SparklineBorder)
], SparklineMarkerSettings.prototype, "border", void 0);
/**
 * To configure the datalabel offset
 */
export class LabelOffset extends ChildProperty {
}
__decorate([
    Property(0)
], LabelOffset.prototype, "x", void 0);
__decorate([
    Property(0)
], LabelOffset.prototype, "y", void 0);
/**
 * To configure the sparkline dataLabel options.
 */
export class SparklineDataLabelSettings extends ChildProperty {
}
__decorate([
    Property([])
], SparklineDataLabelSettings.prototype, "visible", void 0);
__decorate([
    Property(1)
], SparklineDataLabelSettings.prototype, "opacity", void 0);
__decorate([
    Property('transparent')
], SparklineDataLabelSettings.prototype, "fill", void 0);
__decorate([
    Property('')
], SparklineDataLabelSettings.prototype, "format", void 0);
__decorate([
    Complex({ color: 'transparent', width: 0 }, SparklineBorder)
], SparklineDataLabelSettings.prototype, "border", void 0);
__decorate([
    Complex({ size: null, fontWeight: null, fontStyle: null, fontFamily: null }, SparklineFont)
], SparklineDataLabelSettings.prototype, "textStyle", void 0);
__decorate([
    Complex({}, LabelOffset)
], SparklineDataLabelSettings.prototype, "offset", void 0);
__decorate([
    Property('None')
], SparklineDataLabelSettings.prototype, "edgeLabelMode", void 0);
